import { combineReducers } from "redux";

import yearReceiptsDailyReducer from "./yearReceiptsDaily";
import homeTimeIntervalReducer from "./homeTimeInterval";
import homeReceiptsReducer from "./homeReceipts";
import granularSalesStatsReducer from "./granularSalesStats";

const rootReducer = combineReducers({
    yearReceiptsDaily: yearReceiptsDailyReducer,
    homeTimeInterval: homeTimeIntervalReducer,
    homeReceipts: homeReceiptsReducer,
    granularSalesStats: granularSalesStatsReducer,
});

export default rootReducer;
